export default __webpack_public_path__ + "static/media/f_apple.fdd04e40.svg";